function ServicesPage() {
    return (
        <>
            <h1>Services Page</h1>
        </>
    );
}

export default ServicesPage;